import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {BaseComponent} from '../basecomponent.js';
import {ImportUtil} from '../../utils/importUtil.js';

/* global customElements */
class MediaGrid extends BaseComponent {
	
	static get properties() {
		return {				
		};
	}
	
	constructor() {
		super();
		
		var mediaGrid = this;
		setTimeout(function(){
			mediaGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var mediaGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',										
					permissions: ['ADMIN_MEDIA_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')
					],
					listeners: {
						click: function() {							
							actionAdd();
						}
					}					
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'vaadin-button',
					itemid: 'download',					
					'class': 'spacer-toolbar-item',
					disabled: true,
					children:[
						ElementUtil.makeIcon('vaadin:download', ' Download')
					],
					listeners: {
						click: function() {							
							actionDownload(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'dl-action-button',						
					theme: 'error primary',
					itemid: 'delete',					
					'class': 'spacer-toolbar-item',
					style: 'float: right;',
					disabled: true,	
					permissions: ['ADMIN_MEDIA_MANAGEMENT:DELETE'],
					children:[
						ElementUtil.makeIcon('vaadin:trash', ' Delete')
					],
					listeners: {
						click: function() {
							actionDelete(grid.selectedItems[0]);
						}
					}
				}				
				
			]
		});		
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},			
			children: [				
				{						
					path: 'mediaId',
					header: 'Media Id',
					width: '7em'
				},
				{						
					path: 'uniqueName',
					header: 'Name',
					width: '7em'
				},
				{
					path: 'url',
					header: 'URL',
					width: '12em',
					renderer: function(root, column, rowData) {	
						root.innerHTML = '/api/resource/media/' + rowData.item.uniqueName;
					}
				},				
				{						
					path: 'mediaType',
					header: 'Media Type',
					width: '7em'
				},
				{						
					path: 'fileName',
					header: 'File Name',
					width: '7em'
				},
				{						
					path: 'originalName',
					header: 'Original Name',
					width: '7em'
				},				
				{
					path: 'updateDts',
					header: 'Update Date',
					width: '7em',
					renderer: function(root, column, rowData) {	
						root.innerHTML = TimeUtil.formatDateStandard(TimeUtil.parseDate(rowData.item.updateDts));
					}
				},
				{
					path: 'updateUser',
					header: 'Update User',
					width: '7em'										
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {
						ElementUtil.query(toolbar, 'download').disabled = false;	
						ElementUtil.query(toolbar, 'delete').disabled = false;						
					} else {
						ElementUtil.query(toolbar, 'download').disabled = true;
						ElementUtil.query(toolbar, 'delete').disabled = true;						
					}	
				}
			}
		});	
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid
			]
		});		
		mediaGrid.append(flexLayout);		
				
		var actionRefresh = function() {
			var loadMask = grid.showLoading();	
			Service.getMediaService().getAllMedia().then(function(data){
				loadMask.remove();
				
				grid.activeItem = null;
				grid.items = data;				
			});
		};
		actionRefresh();
		
		var actionDownload = function(record) {
			window.location.href = '/api/resource/media/' + record.mediaId + "?download=true";
		};
		
		var actionAdd = function() {
			var uploadWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Upload Media',
				icon: 'vaadin:upload',
				width: 450,
				height: 320,
				listeners: {
					ready: function() {						
						uploadWin.show();
						
						var uploadHandler = function() {
							
							var uploadField = ElementUtil.query(uploadFormPanel, 'uploadField');
														
							if (!uploadField.files || uploadField.files.length < 1) {
								window.DL.MessageUtil.showOkMessage('A resource File is required.');
							} else {
								uploadField.uploadFiles();
							}
							
						};
						
						var uploadFormPanel = ElementUtil.create({
								tag: 'dl-form-panel',
								itemid: 'form',
								children: [									
									{
										tag: 'vaadin-upload',												
										itemid: 'uploadField',
										'no-auto':  true,
										'max-files': 1,
										required: true,
										target: '/api/resource/media',
										headers: ImportUtil.getUploadHeader(),
										listeners: {
											'upload-before': function(event) {
												var file = event.detail.file;
												
												var data = uploadFormPanel.getData();												
												//event.detail.formData.append('uniqueName', data.uniqueName);
												file.uploadTarget = '/api/resource/media?name=' + encodeURIComponent(data.uniqueName);
												
											},
											'upload-success': function(event) {
												var responseData = JSON.parse(event.detail.xhr.responseText);
												if (responseData.uploadFile) {
													//error 
													window.DL.MessageUtil.showOkMessage(
														responseData.uploadFile + '<br>' +
														responseData.uploadFileType ? responseData.uploadFileType : ''
													);
												} else {
													actionRefresh();
													uploadWin.close();
												}
											}
										}
									},
									{
										tag: 'vaadin-form-layout',										
										children: [
											{
												tag: 'vaadin-text-field',
												label: 'Name',
												name: 'uniqueName',												
												required: true,
												'helper-text': 'No Spaces, Special Characters and Lowercase only',
												pattern: '^[a-z0-9]*$',
												maxlength: 120,
												colspan: 2
											}, 
											{
												tag: 'hr',
												colspan: 2
											},
											{
												tag: 'div',
												style: 'text-align: center;',
												colspan: 2,
												defaults: {
													tag: 'vaadin-button'
												},
												children: [
													{
														theme: 'primary',
														children: [
															ElementUtil.makeIcon('vaadin:upload', ' Upload')
														],
														listeners: {
															click: function() {
																if (uploadFormPanel.isValid()) {																	
																	uploadHandler();
																}
															}
														}
													},
													{
														theme: 'tertiary',
														innerHTML: 'Cancel',
														style: 'margin-left: 10px;',
														listeners: {
															click: function() {																
																uploadWin.close();
															}
														}
													}
												]
											}
										]
									}
								]
						});
						uploadWin.addToContentElement(uploadFormPanel);
						
					}
				}
				
				
			});			
			
		};
		
		var actionDelete = function(record) {
			
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to delete media: ' + record.uniqueName  + ' ?<br><br>This may affect branding, help or other features.',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Deleting media...');													

							Service.getMediaService().deleteMedia(record.mediaId).then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Deleted media: ' + record.uniqueName, {									
									theme: 'success'
								});
								actionRefresh();
							});															

						}	
					},
					{
						text: 'No'
					}
				]
			});				
			
		};
		
	}
	
};
customElements.define('dl-media-grid', MediaGrid);


